export default "__VITE_ASSET__Dll2waQA__"